import React, { useState } from "react";
import styled from "styled-components";
import ChevronButton from "../../core/Button/ChevronButton";

const DataInfo = (
  { siteDescription, dataInfo }
) => {
  const [close, setClose] = useState(true);;

  return (
    <InfoWrapper>
      <Header onClick={() => setClose(current => !current)} $close={close}>
        <span>Information</span>
        <ChevronButton isOpen={!close} />
      </Header>
      {!close && (
        <DataList>
          <DataItem style={{ marginBottom: "0.5rem" }}>
            {siteDescription}
          </DataItem>
          {Object.keys(dataInfo).map((key, index) => (
            <DataItem key={index}>
              <p className="key">{key} : </p>
              <p className="value">{dataInfo[key]}</p>
            </DataItem>
          ))}
        </DataList>
      )}
    </InfoWrapper>
  );
};

export default DataInfo;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  /* align-items: end; */
  float: right;
  /* margin: 2rem 0 3rem 0; */
  position: absolute;
  top: 1rem;
  right: 1rem;

  z-index: 100;

  @media screen and (max-width: 480px) {
    display: none;
  }
`;

const Header = styled.div`
  text-align: center;
  padding: 0.5rem 1.5rem;
  background-color: lightgray;
  color: black;
  box-sizing: border-box;
  border: 1px solid lightgray;
  border-radius: ${({ $close }) => ($close ? "5px" : "")};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
`;

const DataList = styled.ul`
  position: absolute;
  z-index: 10;
  top: 2.4375rem;
  right: 0;
  background-color: #001526;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  font-size: 1rem;
  font-weight: 600;
  border: 2px solid lightgray;
  border-radius: 5px 0 5px 5px;
  gap: 0.3rem;
  margin: 0;
`;

const DataItem = styled.li`
  display: flex;
  white-space: pre;
  .key {
    width: 10rem;
  }
`;
